import * as React from 'react';

import * as styles from './styles.css';

import { LinkItem } from './Link';
import { Typography } from '../Typography';
import logo from '../../assets/images/logo.svg';
import { Image, useDeviceType } from '@cian/ui-kit';
import { IFooterInfo } from '../../types/footer';
import cn from 'clsx';
import { MapMarker24 } from '../Icons/24/MapMarker24';

interface IFooterProps {
  content: IFooterInfo;
}

export const Footer: React.FC<IFooterProps> = ({ content }) => {
  const deviceType = useDeviceType();

  if (deviceType !== 'desktop') {
    return (
      <footer className={cn(styles['container'], styles[deviceType])}>
        <div className={cn(styles['content'])}>
          <div className={cn(styles['top-block'], styles[deviceType])}>
            <div className={cn(styles['about'], styles[deviceType])}>
              <div className={styles['title']}>
                <LinkItem name="hr@cian.ru" href="mailto:hr@cian.ru" />
              </div>
            </div>
            <ul className={cn(styles['links'], styles[deviceType])}>
              {content.links.map(link => (
                <li key={link.name}>
                  <LinkItem name={link.name} href={link.href} />
                </li>
              ))}
            </ul>
          </div>
          <div className={styles['bottom-block']}>
            <ul className={cn(styles['contacts'], styles[deviceType])}>
              {content.contacts.map(contact => (
                <li key={contact.city} className={styles['address']}>
                  <div className={styles['city']}>
                    <MapMarker24 color="currentColor" />
                    <Typography.Text color="currentColor" level={3}>
                      {contact.city}
                    </Typography.Text>
                  </div>
                  <Typography.Text color="currentColor" level={3}>
                    {contact.address}
                  </Typography.Text>
                </li>
              ))}
            </ul>
          </div>
          <div className={cn(styles['logo'], styles[deviceType])}>
            <a href={'https://www.cian.ru/'} target="_blank" rel="noreferrer" className={styles['logo-link']}>
              <Image src={logo} width="100%" height="100%" />
            </a>
            <div className={styles['copy']}>
              <Typography.Text color="currentColor" level={6}>
                {content.copy}
              </Typography.Text>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={styles['container']}>
      <div className={cn(styles['content'])}>
        <div className={styles['top-block']}>
          <div className={styles['about']}>
            <div className={styles['title']}>
              <LinkItem name="hr@cian.ru" href="mailto:hr@cian.ru" />
            </div>
            <div className={styles['logo']}>
              <a href="https://www.cian.ru/" target="_blank" rel="noreferrer" className={styles['logo-link']}>
                <Image src={logo} width="100%" height="100%" />
              </a>
              <div className={styles['copy']}>
                <Typography.Text color="currentColor" level={6}>
                  {content.copy}
                </Typography.Text>
              </div>
            </div>
          </div>
          <ul className={styles['links']}>
            {content.links.map(link => (
              <li key={link.name}>
                <LinkItem name={link.name} href={link.href} />
              </li>
            ))}
          </ul>
        </div>
        <div className={styles['bottom-block']}>
          <ul className={styles['contacts']}>
            {content.contacts.map((contact, index) => (
              <li key={`${contact.city}-${index}`} className={styles['address']}>
                <div className={styles['city']}>
                  <MapMarker24 color="currentColor" />
                  <Typography.Text color="currentColor" level={3}>
                    {contact.city}
                  </Typography.Text>
                </div>
                <Typography.Text color="currentColor" level={3}>
                  {contact.address}
                </Typography.Text>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';
